import { AccountLockIcon } from './AccountLockIcon';

/**
 * author: Michael Irigoyen
 * id BD94D7C7-DFDF-419F-862E-FB1AC3263967
 * name account-lock
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-lock.svg
 * tags
 * - Account / User 
 * - Lock 
 */
export const PersonLockIcon = AccountLockIcon;
export default PersonLockIcon